export var RfrrPageNamespace;
(function (RfrrPageNamespace) {
  RfrrPageNamespace["Infosite"] = "HOT.HIS";
  RfrrPageNamespace["Search"] = "HOT.SR";
})(RfrrPageNamespace || (RfrrPageNamespace = {}));
export const SEARCH_ID = 'searchId';
export const PRICE_REQUEST_CALIFORNIA_SUBMITTED = 'price_request_california.submitted';
export const CLICKSTREAM_CONFIG = {
  isEgClickstream: true
};